import { Actions, types } from "../actions"
import { ElasticContact } from "../models"

export type Contacts = Array<ElasticContact>

export type ContactListingStore = {
    contactList: Contacts
    isLoading: boolean
    error: string
}

const defaultState: ContactListingStore = {
    contactList: [],
    isLoading: false,
    error: ""
}

export function contactListingReducer(state = defaultState, action: Actions) {
    switch (action.type) {
    case types.FETCH_CONTACTS:
        return {
            ...defaultState,
            isLoading: true
        }
    case types.FETCH_CONTACTS_SUCCESS:
        return {
            ...defaultState,
            contactList: [...(action.payload as Contacts)],
            isLoading: false
        }
    case types.FETCH_CONTACTS_ERROR:
        return {
            ...defaultState,
            error: (action.payload as { errorMessage: string }).errorMessage,
            isLoading: false
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./src/state/listing/contact/reducers/contactListingReducers.ts